import React from 'react';
import { Card } from 'react-bootstrap';
import { UploadButton } from '@rd-web-markets/shared/dist/util/buttons';
export default function DataCenterDataType(_ref) {
  let {
    canUploadTemplate,
    goToProgressPage,
    typeName,
    uploadButtonsSettings
  } = _ref;
  return /*#__PURE__*/React.createElement(Card, {
    className: "my-4",
    style: {
      width: '100%'
    }
  }, /*#__PURE__*/React.createElement(Card.Header, {
    className: "bg-primary bg-gradient text-white text-start"
  }, typeName), /*#__PURE__*/React.createElement(Card.Body, {
    className: "p-4 d-flex justify-content-between"
  }, uploadButtonsSettings.map(uploadButtonsSettings => /*#__PURE__*/React.createElement(UploadButton, {
    className: "me-2",
    id: uploadButtonsSettings.buttonId,
    disabled: uploadButtonsSettings.disabled || canUploadTemplate,
    isImmutableUnderReview: true,
    style: {
      width: '240px'
    },
    onClick: () => uploadButtonsSettings.onClick ? uploadButtonsSettings.onClick() : goToProgressPage(uploadButtonsSettings.progressPageString),
    text: uploadButtonsSettings.text
  }))));
}